import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LogInterceptor } from './log.interceptor';
import { CorsInterceptor } from './cors.interceptor';
import { DataExtractorInterceptor } from './data-extractor.interceptor';
import { ErrorInterceptor } from './error.interceptor';

export const interceptorProviders = [
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: CorsInterceptor,
  //   multi: true,
  // },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LogInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DataExtractorInterceptor,
    multi: true,
  },

  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
];
